/**
 * @generated SignedSource<<12423b962640ecaa9aa572077dec70f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortableEntityTableRow_entity$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "SortableEntityTableRow_entity";
};
export type SortableEntityTableRow_entity$key = {
  readonly " $data"?: SortableEntityTableRow_entity$data;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SortableEntityTableRow_entity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "2d564bee1841da1b8afd60fdacbb4405";

export default node;
